import type { DeclarativeNif } from "../flow/types";
import { FullCountry, RealIdentity } from "../user/types";

export type RegisterCredentialType = {
  FirstName: string | null;
  LastName: string | null;
  email: string | null | undefined;
  telephone: string | null;
  password: string | null | undefined;
  confirm_password: string | null | undefined;
  accept_condition: string | null;
  captcha_token?: string | null;
  language?: string | null;
  real_uuid?: string | null;
  jwt_otp: string | null;
};

export type CheckEmailProps = {
  email: string | null | undefined;
  captcha_token?: string | null;
  language?: string | null;
};

export type VerifyEmailCredentials = {
  email: string | null | undefined;
  captcha_token?: string | null;
  language?: string | null;
};

export type ErrorResponse<T> = Omit<T, "success"> & { success: false };

export type CheckEmailResponse = {
  code: number;
  success: boolean;
  data: { cypher: string };
  message: string;
};
export type ConfirmationResponseData<T> = {
  code?: number;
  success: boolean;
  message: string;
  data?: T | null;
};

export type ConfirmationResponse = {
  code?: number;
  success: boolean;
  message: string;
};

export type MatchingUuidEmailResponse = {
  foundMirror: boolean;
  isAccountComplete: boolean;
};

export type taxAddressReq = {
  taxAddress: DeclarativeNif | DeclarativeNif[];
};

type TaxAddressItemSuccessResponse = {
  country: FullCountry;
  api_check: boolean;
  tin: string | null;
  tin_exist: boolean;
  real_identity: RealIdentity;
  id: number;
  uuid: string;
  created_at: string;
  updated_at: string;
  deleted_date: string | null;
};

type TaxAddressErrorResponse = { data: string };
type TaxAddressSuccessResponse = TaxAddressItemSuccessResponse[];

export type CreateTaxAddressResponse = TaxAddressErrorResponse | TaxAddressSuccessResponse;
export const isCreateTaxAddressResponseSuccess = (
  response: CreateTaxAddressResponse
): response is TaxAddressSuccessResponse => {
  return "uuid" in response[0];
};

export type EditTaxAddressResponse = TaxAddressItemSuccessResponse | TaxAddressErrorResponse;
export const isUpdateTaxAddressResponseSuccess = (
  response: EditTaxAddressResponse
): response is TaxAddressItemSuccessResponse => {
  return "uuid" in response;
};

export type CreateAccountMirrorResponse = {
  token: string;
};
